import { motion } from 'framer-motion';
import { useI18n } from '../context/I18nContext';
import { Quote } from 'lucide-react';

export const SocialProofSection = () => {
  const { t } = useI18n();
  const quotes = t('social_proof.quotes');

  return (
    <section className="relative py-12 sm:py-20 bg-muted border-y border-border" data-testid="social-proof-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <p className="text-center text-xs sm:text-sm text-muted-foreground uppercase tracking-widest mb-8 sm:mb-12" data-testid="social-proof-label">
          {t('social_proof.label')}
        </p>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {Array.isArray(quotes) && quotes.map((q, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }}
              className="group p-6 rounded-xl bg-card border border-border hover:border-blue-500/20 transition-colors duration-300"
              data-testid={`social-proof-quote-${i}`}>
              <Quote className="w-5 h-5 text-blue-500/50 mb-4" />
              <p className="text-foreground/80 text-base leading-relaxed mb-4">"{q.text}"</p>
              <div>
                <p className="text-foreground font-medium text-sm">{q.author}</p>
                <p className="text-muted-foreground text-xs">{q.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
